module.exports = __webpack_public_path__ + "static/shotlists_notes-2dd8781a54ca5aa866e519c199ea5701.png";